export const SCREENS = {
  METARACT_HISTORY: "METARACT_HISTORY",
  JOINED_COMMUNITIES: "JOINED_COMMUNITIES",
};

export default SCREENS;
